import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const StyledRadioList = styled.div`
  & > div:not(:first-of-type) {
    margin-top: ${spacing.half};
  }
`;
